import { testRequiredOptions } from 'www/utils'
import { apiScheduleTelemed } from 'www/api'
import { AppointmentModules } from 'www/modules/appointment-modules'
import { PAGE_TYPE_DATA } from 'www/modules/Schedule/constants'

const {
  getAppointmentLpusSlots,
  getAppointmentDoctorsSlots,
  getAppointmentServicesSlots,
} = new AppointmentModules()

/**
 * @description
 *
 * Производит запрос за слотами
 *
 * @param {object} options -
 * @param {string} options.pageType - тип страницы, одно из значений константы 'PAGE_TYPE_DATA'
 * @param {object} options.data - данные для запроса
 *
 * @returns { Promise | undefined } -
 */

function scheduleRequest({ pageType, data, isTelemed } = {}) {
  const testOptions = testRequiredOptions({
    module: 'scheduleRequest',
    requiredOptions: { data, pageType },
  })

  if (!testOptions) {
    return
  }

  if (isTelemed) {
    return apiScheduleTelemed.post(data)
  }

  switch (pageType) {
    case PAGE_TYPE_DATA.lpu:
      return getAppointmentLpusSlots(data)
    case PAGE_TYPE_DATA.doctors:
    case PAGE_TYPE_DATA.doctorsLpu:
      return getAppointmentDoctorsSlots(data)
    case PAGE_TYPE_DATA.services:
      return getAppointmentServicesSlots(data)
  }
}

export default scheduleRequest
